import React, { useState, useEffect } from "react";
import { Home as HomeIc, Calendar, CalendarDays, User } from "lucide-react";
import api from "../api";
import { Home } from "./tabs/Home";
import { Attendance } from "./tabs/Attendance";
import { Leaves } from "./tabs/Leaves";
import { Profile } from "./tabs/Profile";
import { todayStr } from "./utils";

const TABS = [
  { k: "home", l: "Home", Ic: HomeIc },
  { k: "attendance", l: "Attendance", Ic: Calendar },
  { k: "leaves", l: "Leaves", Ic: CalendarDays },
  { k: "profile", l: "Profile", Ic: User },
];

export const Shell = ({ me, onLogout, onRefreshMe }) => {
  const [tab, setTab] = useState("home");
  const [todayRec, setTodayRec] = useState(null);
  const [balances, setBalances] = useState([]);
  const [types, setTypes] = useState([]);
  const [freeze, setFreeze] = useState({ enabled: false, start: "04-11", end: "04-15", message: "" });

  const refresh = () => {
    api.get('/api/attendance').then(d => {
      const today = todayStr();
      const myEmpId = me?.user?.employee_id;
      const rec = (d?.today_records || []).find(r => (r.employee_id === myEmpId || r.emp_code === myEmpId) && (!r.date || r.date.toString().slice(0, 10) === today));
      // A night shift checks in on one date and checks out on the next, so the record may be dated yesterday. The
      // server reports it as my_open_record while the check-out window (shift end + 5h) is still open — use that first,
      // otherwise the app shows "Check In" after midnight and the Check Out button never appears.
      const open = d?.my_open_record;
      setTodayRec((open && open.checkout_window_open) ? open : (rec || null));
    }).catch(() => {});
    api.get('/api/leaves/balance').then(d => setBalances(d?.data || d || [])).catch(() => {});
    api.get('/api/leaves/types').then(d => setTypes(d?.data || d || [])).catch(() => {});
    api.get('/api/leaves/freeze-window').then(d => setFreeze(d || freeze)).catch(() => {});
  };
  // eslint-disable-next-line
  useEffect(refresh, [me?.user?.employee_id]);

  return <div className="min-h-screen bg-bg text-t0 max-w-[480px] mx-auto relative">
    {tab === "home" && <Home me={me} todayRec={todayRec} onGoAttendance={() => setTab("attendance")} />}
    {tab === "attendance" && <Attendance me={me} todayRec={todayRec} onRefresh={refresh} />}
    {tab === "leaves" && <Leaves balances={balances} types={types} freeze={freeze} onRefresh={refresh} />}
    {tab === "profile" && <Profile me={me} onLogout={onLogout} onRefreshMe={onRefreshMe} />}

    <div className="fixed bottom-0 left-0 right-0 bg-s border-t border-b0 shadow-[0_-2px_10px_rgba(0,0,0,0.05)] z-50">
      <div className="max-w-[480px] mx-auto flex pt-[6px]" style={{ paddingBottom: "max(8px, env(safe-area-inset-bottom))" }}>
        {TABS.map(t => (
          <button
            key={t.k}
            onClick={() => setTab(t.k)}
            className={`flex-1 bg-transparent border-0 px-1 py-2 flex flex-col items-center gap-[3px] cursor-pointer ${tab === t.k ? "text-p" : "text-t3"}`}
          >
            <t.Ic size={22} strokeWidth={tab === t.k ? 2.4 : 1.8} />
            <span className={`text-[14px] ${tab === t.k ? "font-bold" : "font-medium"}`}>{t.l}</span>
          </button>
        ))}
      </div>
    </div>
  </div>;
};
